import io from 'socket.io-client';
import isJson from 'helpers/isJson';

let thisSocketToken;
export let pureSocket;
let listeners = {};

function customSocketObject(socket) {

  return {
      emit: (type, payload, initial, callback) => {
        if (listeners[type] && initial) {
          listeners[type] = payload;
        }
        if (initial && payload && listeners[type] && !Object.keys(listeners[type]).length) {
          listeners[type] = payload;
        }
        let rmOnFromType = type.replace('@WS_ON', '');
        rmOnFromType = rmOnFromType.split('+')[0];
        if (thisSocketToken) return socket.emit(rmOnFromType, {...payload, token: thisSocketToken}, callback);
        return socket.emit(rmOnFromType, payload, callback);
        
      },
      on: (type, payload, skipList) => {
        if (listeners[type]) return;
        if (!skipList) listeners[type] = {};
        return socket.on(type, payload);
      },
      off: (type) => {
        if (listeners[type]) {
          delete listeners[type];
        }
        return socket.off(type);
      },
  }
}


const WS_ON = '@WS_ON';
const WS_OFF = '@WS_OFF';
const WS_EMIT = '@WS_EMIT';

export function wsOn(payload) {
  return {
    type: WS_ON,
    payload,
  };
}

export function wsOff(payload) {
  return {
    type: WS_OFF,
    payload,
  };
}

export function wsEmit(payload) {
  return {
    type: WS_EMIT,
    payload,
  };
}

export const socket = (thisUrl, params) => {

  const thisSocket = io(thisUrl, {
    ...params,
    withCredentials: true,
  });

  if (!pureSocket) pureSocket = customSocketObject(thisSocket);
  
  thisSocket.on('connect', function(){
    Object.entries(listeners).forEach(([key, value]) => {
      if (Object.keys(value).length && pureSocket) return pureSocket.emit(key, value);
    });
  });

  return thisSocket;

};


export const connectSocket = (socket) => store => next => action => {

  const nextAction = next(action);

  if (!socket) return nextAction;

  const actionType = action.type.match(/^[@WS_]*/i)[0] === '@WS_';
  if (!actionType) return nextAction;

  const { payload } = action;
  const thisWs = payload.ws;
  const thisAction = payload.action;
  const thisData = action.payload.data;
  const thisListener = thisWs + action.type;

  if (listeners[thisListener]) return nextAction;

  if (action.type.match(/^[@WS_ON]*/i)[0] === '@WS_ON') listeners[thisListener] = {};

  switch (action.type) {
    case '@WS_EMIT':
      const onListener = thisWs+WS_ON;
      if (thisData && listeners[onListener] && action.payload.initial) {
        const multipleId = action.payload.multipleId ? '+'+action.payload.multipleId : '';
        listeners[onListener+multipleId] = thisData;
      }
      socket.emit(thisWs, thisSocketToken ? {...thisData, token: thisSocketToken} : thisData);
      break;
    case '@WS_ON':
      socket.on(thisWs, (data) => {
        if (!data) return nextAction;
        
        let thisData = isJson(data);
        if (!thisData && data) thisData = isJson(JSON.stringify(data));

        if (thisData && thisData.data && thisData.data.token && !thisSocketToken) thisSocketToken = thisData.data.token;
        if (thisData) store.dispatch({ type: thisAction, payload: thisData });
      });
      break;
    case '@WS_OFF':
      const removThisListener = `${thisWs}@WS_ON`;

      Object.entries(listeners).forEach(([key, value]) => {
        if (key.includes(removThisListener)) delete listeners[removThisListener];        
      });

      
      socket.off(thisWs);
      break;
  }


};

export default [
  socket,
  pureSocket,
  connectSocket,
  wsOn,
  wsOff,
  wsEmit,
];
